import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { FEATURE_BADGES, getFeatureBadge } from '../constants/feature-badges'
import Badge from './tailwind/Badge'

// Neu für eine neue Funktion, Verbessert für eine bestehende, die mehr kann.
// Eigene Farbe, damit beide nicht verwechselt werden.
const KINDS = {
  new: { text: 'global.new', color: 'pink' },
  improved: { text: 'global.improved', color: 'blue' }
}

// Badge einer Funktion aus FEATURE_BADGES, nach Ablauf nichts
const FeatureBadge = ({ id }) => {
  const { t } = useTranslation()

  const kind = getFeatureBadge(id)
  if (!kind) return null

  return (
    <Badge text={t(KINDS[kind].text)} color={KINDS[kind].color} type='basic' />
  )
}

FeatureBadge.propTypes = {
  id: PropTypes.oneOf(Object.keys(FEATURE_BADGES)).isRequired
}

export default FeatureBadge
